module.exports = __webpack_public_path__ + "884e7f97a321e3dda41076bbaef04f81.svg";